import { Button } from "@/components/ui/button";
import { Settings, Trash } from "lucide-react";

export const ItemHeader: React.FC<{
    title: string;
    onTitleChange: (t: string) => void;
    onToggleConditional?: () => void;
    onDelete?: () => void;
}> = ({ title, onTitleChange, onToggleConditional, onDelete }) => (
    <div className="flex items-center gap-2 w-full">
        <input
            type="text"
            value={title}
            onChange={(e) => onTitleChange(e.target.value)}
            className="flex-1 text-sm border-b border-transparent focus:border-gray-400 outline-none bg-transparent truncate"
            placeholder="Untitled"
        />

        <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition">
            {onToggleConditional && (
                <Button size="sm" variant="ghost" onClick={onToggleConditional}>
                    <Settings size={16} />
                </Button>
            )}
            {onDelete && (
                <Button size="sm" variant="destructive" onClick={onDelete}>
                    <Trash size={16} />
                </Button>
            )}
        </div>
    </div>
);